module.exports = __webpack_public_path__ + "img/2_1-macerie-1.1bd33111.png";